import { JsonLd } from "~/components/JsonLd";
import { buildMeta, getCompanyFromMatches } from "~/utils/meta-helpers";

// ═══ LAUNCH LANDING (wireframe v7, 2026-07-24) — single-page conversion home. ═══
// Secciones anteriores OCULTAS pero INTACTAS (revertir = descomentar):
// import { HeroSlider } from "../components/HeroSlider/HeroSlider";
// import { WhatIsAcademiaCard } from "../components/HomeSections/WhatIsAcademiaCard";
// import { IAPracticaCoursesSection } from "../components/HomeSections/IAPracticaCoursesSection";
// import { WhoIsItForSection } from "../components/HomeSections/WhoIsItForSection";
// import { HomeTestimonialsSection } from "../components/HomeSections/HomeTestimonialsSection";
// import { CategoriesShowcase } from "../components/HomeSections/CategoriesShowcase";
// import { FeaturedCoursesSection } from "../components/FeaturedCourses/FeaturedCoursesSection";
// import { HowItWorksSection } from "../components/HomeSections/HowItWorksSection";
// import { B2BTeaserSection } from "../components/HomeSections/B2BTeaserSection";
// import { FinalCtaSection } from "../components/HomeSections/FinalCtaSection";
import { useHashScroll } from "../components/CuadernoVivo/useHashScroll";
import { CertificateSection } from "../components/HomeSections/CertificateSection";
import { EscalonCero } from "../components/HomeSections/EscalonCero";
import { EscalonPuente } from "../components/HomeSections/EscalonPuente";
import { FAQPreviewSection } from "../components/HomeSections/FAQPreviewSection";
import { FeaturedFreeCourse } from "../components/HomeSections/FeaturedFreeCourse";
import { FinalCtaLaunch } from "../components/HomeSections/FinalCtaLaunch";
import { LaunchHero } from "../components/HomeSections/LaunchHero";
import { MethodSection, QuotesSection } from "../components/HomeSections/MethodQuotesSection";
// ─── OCULTAS (no borradas). Simplificación de la home, 2026-07-31 ────────────────
// "Próximamente" (pre-inscripción −80%): sigue viva y en uso en /courses.
// import { PreinscriptionSection } from "../components/HomeSections/PreinscriptionSection";
// "Cada uno llega por algo distinto": la identificación por persona no sumaba como
// estaba presentada. El componente y sus ilustraciones quedan intactos.
// import { PersonasSection } from "../components/HomeSections/PersonasSection";
// "Rutas de aprendizaje": el mapa de rutas no se lanza ni se comunica todavía. Queda
// entero para cuando exista el catálogo que promete. Su lugar lo ocupa el certificado.
// import { LearningPathsSection } from "../components/HomeSections/LearningPathsSection";

import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = ({ matches }) => {
  const company = getCompanyFromMatches(matches);
  return buildMeta({
    title: company,
    description:
      "Aprendé IA en español, explicada para que la entienda cualquiera. Empezá hoy, gratis.",
  });
};

export default function HomePage() {
  // "/#cursos" y compañía desde otras páginas: scroll diferido hasta que la sección monte.
  useHashScroll();

  return (
    // Base cálida detrás de todo: las secciones semitransparentes componen sobre
    // esta crema (no sobre el blanco del body), así conservan su color.
    <div className="relative">
      {/* Hero (gancho universal) */}
      <LaunchHero />

      {/* Zona "empezá": fondo blanco + ripple compartido. La Hoja Corregida es una card
          SUPERPUESTA (z-index) que puentea el hero con el curso gratis — el ripple corre
          por detrás de ella, no arranca recién debajo. */}
      <div className="relative bg-landing-white">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 opacity-[0.1]"
          style={{
            backgroundImage:
              "repeating-radial-gradient(ellipse 900px 520px at 78% 30%, transparent 0 38px, rgba(43,125,135,.5) 38px 39.5px)",
          }}
        />
        {/* Difumina la costura hero(crema)→zona(blanca) para que la card se superponga
            sin un corte duro */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-x-0 top-0 h-44 bg-gradient-to-b from-landing-cream to-transparent"
        />
        {/* flex-col evita el colapso de márgenes: el -mt del conector sube limpio y el
            curso gratis lo sigue sin dejar un hueco */}
        <div className="relative z-10 flex flex-col">
          {/* Conector hero→curso (se superpone al borde tirando hacia arriba con el -mt) */}
          <EscalonCero />
          {/* Respiro entre las dos cards: por qué acá y no un tutorial suelto. Va sin
              card a propósito — dos cajas seguidas se leen como una lista y ninguna
              pesa. */}
          <EscalonPuente />
          {/* El protagonista: curso destacado gratis (admin-configurable) — ancla #cursos */}
          <FeaturedFreeCourse />
        </div>
      </div>

      {/* Certificado verificable tokenizado, con ejemplo. Ocupa el lugar que tenían
          Personas y Rutas (ver imports comentados arriba). */}
      <CertificateSection />

      {/* "Quiénes somos" se mudó a su propia página: /quienes-somos */}

      {/* Así se estudia */}
      <MethodSection />

      {/* Palabras de los que ya empezaron (anónimos, grupo beta) */}
      <QuotesSection />

      {/* Preguntas — #faq */}
      <FAQPreviewSection />

      {/* Cierre aspiracional */}
      <FinalCtaLaunch />

      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "AcademIA",
          url: "https://cursosacademia.ar",
          description:
            "Plataforma de cursos de inteligencia artificial en español, explicados para que los entienda cualquiera",
        }}
      />
    </div>
  );
}
